import { defineComponent, computed, inject, createVNode, Fragment } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import UploadProgress from "./upload-progress.js";
import { uploadInjectionKey } from "./context.js";
import IconImageClose from "../icon/icon-image-close/index.js";
import IconEye from "../icon/icon-eye/index.js";
import IconUpload from "../icon/icon-upload/index.js";
import IconDelete from "../icon/icon-delete/index.js";
var UploadPictureItem = defineComponent({
  name: "UploadPictureItem",
  props: {
    file: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const prefixCls = getPrefixCls("upload-list");
    const itemCls = `${prefixCls}-picture`;
    const cls = computed(() => [itemCls, {
      [`${itemCls}-status-error`]: props.file.status === "error"
    }]);
    const uploadCtx = inject(uploadInjectionKey, void 0);
    const renderCard = () => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      if (props.file.status === "uploading") {
        return createVNode(UploadProgress, {
          "file": props.file,
          "listType": "picture-card"
        }, null);
      }
      return createVNode(Fragment, null, [createVNode("img", {
        "src": props.file.url
      }, null), createVNode("div", {
        "class": `${itemCls}-mask`
      }, [props.file.status === "error" && createVNode("div", {
        "class": `${itemCls}-error-tip`
      }, [createVNode("span", {
        "class": [uploadCtx == null ? void 0 : uploadCtx.iconCls, `${uploadCtx == null ? void 0 : uploadCtx.iconCls}-error`]
      }, [((_b = (_a = uploadCtx == null ? void 0 : uploadCtx.customIcon) == null ? void 0 : _a.errorIcon) == null ? void 0 : _b.call(_a)) || createVNode(IconImageClose, null, null)])]), createVNode("div", {
        "class": `${itemCls}-operation`
      }, [props.file.status !== "error" && createVNode("span", {
        "class": [uploadCtx == null ? void 0 : uploadCtx.iconCls, `${uploadCtx == null ? void 0 : uploadCtx.iconCls}-preview`],
        "onClick": () => uploadCtx == null ? void 0 : uploadCtx.onPreview(props.file)
      }, [((_d = (_c = uploadCtx == null ? void 0 : uploadCtx.customIcon) == null ? void 0 : _c.previewIcon) == null ? void 0 : _d.call(_c)) || createVNode(IconEye, null, null)]), ["init", "error"].includes(props.file.status) && createVNode("span", {
        "class": [uploadCtx == null ? void 0 : uploadCtx.iconCls, `${uploadCtx == null ? void 0 : uploadCtx.iconCls}-upload`],
        "onClick": () => uploadCtx == null ? void 0 : uploadCtx.onUpload(props.file)
      }, [((_f = (_e = uploadCtx == null ? void 0 : uploadCtx.customIcon) == null ? void 0 : _e.retryIcon) == null ? void 0 : _f.call(_e)) || createVNode(IconUpload, null, null)]), !(uploadCtx == null ? void 0 : uploadCtx.disabled) && createVNode("span", {
        "class": [uploadCtx == null ? void 0 : uploadCtx.iconCls, `${uploadCtx == null ? void 0 : uploadCtx.iconCls}-remove`],
        "onClick": () => uploadCtx == null ? void 0 : uploadCtx.onRemove(props.file)
      }, [((_h = (_g = uploadCtx == null ? void 0 : uploadCtx.customIcon) == null ? void 0 : _g.removeIcon) == null ? void 0 : _h.call(_g)) || createVNode(IconDelete, null, null)])])])]);
    };
    return () => createVNode("span", {
      "class": cls.value
    }, [renderCard()]);
  }
});
export { UploadPictureItem as default };
